module.exports = {"username":"Username","username_placeholder":"Create username","username_taken":"This username is already taken","username_taken_long":"This username is already taken, please try another","username_short":"Too few characters, type more"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/username.json
// module id = 540
// module chunks = 245 947